import styled from 'styled-components';
import { animated } from 'react-spring';
import {
  Container as RawContainer,
  InfoBlock as InfoBlockBase,
  size,
  mediaQueries,
  colors,
  typography,
  Button,
  Col,
} from '@everlywell/leaves';

import RawSectionTitle from '../../Enterprise/SectionTitle';
import SectionWrapper from 'components/SectionWrapper';

const colorMap = {
  Primary: colors.white,
  Secondary: colors.teal1,
};

export const Wrapper = styled(SectionWrapper).attrs(props => ({
  backgroundColor: props.backgroundColor,
}))`
  background-color: ${({ backgroundColor }) => colorMap[backgroundColor]};
  background-image: ${props =>
    props.backgroundColor
      ? 'none'
      : `linear-Gradient(to top, ${colors.teal1} 60%, ${colors.white} 97%)`};
`;

export const Container = styled(RawContainer)`
  padding-top: ${size.md}px;
  padding-bottom: ${size.md}px;

  ${mediaQueries.forTabletHorizontalUp} {
    padding-top: ${size.xl1}px;
    padding-bottom: ${size.xl2}px;
  }
`;

export const InfoBlock = styled(InfoBlockBase).attrs(props => ({
  imageAlt: props.imageAlt,
}))`
  ${typography.bodyText};
`;

export const AnimatedBlockContainer = styled(animated.div)`
  margin-top: ${size.md}px;
  margin-bottom: ${size.md}px;
  div[class*='InfoBlock-'] {
    div:first-child {
      background-color: transparent;
    }
  }

  ${mediaQueries.forTabletHorizontalUp} {
    flex: 0 0 33%;
    &:not(:last-child) {
      padding-right: ${size.lg}px;
    }
  }
`;

export const InfoBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  ${AnimatedBlockContainer} {
    &:last-child {
      ${InfoBlock} {
        margin-bottom: 0;
      }
    }
  }
`;

export const SectionTitle = styled(RawSectionTitle)`
  text-align: center;
  margin-bottom: ${size.sm}px;
`;

export const SectionHeadline = styled.h2`
  ${typography.h3Text}
  font-weight: normal !important;
  margin-bottom: ${size.lg}px;
  text-align: center;
  ${mediaQueries.forTabletHorizontalUp} {
    margin: 0 auto;
    max-width: 648px;
  }
`;

export const Title = styled(RawSectionTitle)`
  text-align: left;
`;

export const Headline = styled.h2`
  ${typography.h2Text}
  text-align: left;
  margin-bottom: ${size.xs1}px;
`;

export const HeadlineDescription = styled.p`
  ${typography.bodyText};
  text-align: left;
  margin-top: ${size.xs1}px;
  margin-bottom: 0;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.xl4}px;
  }
`;

export const Copy = styled.p`
  ${typography.bodyText};
  text-align: left;
  margin-bottom: ${size.xl3}px;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: 0;
  }
`;

export const ParallaxImagesCol = styled(Col)`
  order: 1;
  ${mediaQueries.forTabletHorizontalUp} {
    order: 0;
  }
`;

export const MainImageContainer = styled.div`
  z-index: -1;
  margin-top: ${size.xl5}px;
  margin-bottom: ${size.md}px;
  ${mediaQueries.forDesktopUp} {
    margin-top: ${size.xl4}px;
  }
`;

export const MobileAnimatedImage = styled(animated.div)`
  max-height: 412px;
  width: auto;
  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const MobileAnimatedComponent = styled(animated.div)`
  max-height: 412px;
  width: auto;
  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const MobileImageContainer = styled.div`
  position: relative;
  max-width: 365px;
  margin: 0 auto;
  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

export const DesktopImageContainer = styled.div`
  position: relative;
  display: none;
  ${mediaQueries.forTabletHorizontalUp} {
    display: block;
  }
`;

export const TopImage = styled(animated.div)`
  position: absolute;
  top: 0;
  left: 30%;
  width: 100%;
  max-width: 245px;
  ${mediaQueries.forTabletHorizontalUp} {
    max-width: 294px;
    top: -2rem;
    left: unset;
    right: 3rem;
  }
`;

export const BottomImage = styled(animated.div)`
  position: absolute;
  left: 30%;
  top: 8rem;
  width: 100%;
  max-width: 245px;
  ${mediaQueries.forTabletHorizontalUp} {
    max-width: 517px;
    top: unset;
    bottom: -5rem;
    left: 0rem;
  }
`;

export const MiddleImage = styled.div`
  width: 100%;
  max-width: 530px;
  margin: 0 auto;
`;

export const Content = styled.div`
  margin-top: ${size.xl1}px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: 0;
  }
`;

export const SubHeadline = styled.div`
  ${typography.h3Text};
  text-align: left;
`;

export const SubHeadlineDescription = styled.p`
  ${typography.bodyText};
  text-align: left;
  margin-top: ${size.xs1}px;
`;

export const CTA = styled(Button)`
  width: max-content;
  margin-top: ${size.lg}px;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: ${size.xl1}px;
  }
`;
